module.exports = __webpack_public_path__ + "img/loader_background.223f5b80.jpg";